module.exports = __webpack_public_path__ + "static/barge-2b7a5d7120e150253a0f5e73cc1525ad.jpg";